import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UpcomingTimeIcon from '../../images/dashboard/time_icon.svg';
import UpcomingRouteIcon from '../../images/dashboard/upcomig_route.svg';
import './Dashboard.css';

/**
 * DashboardUpcomingCards Component
 * Displays upcoming trip cards with vehicle, time, and route information
 * @param {Object[]} schedules - Array of schedule objects containing trip details
 */
export default function DashboardUpcomingCards({ schedules = [] }) {
    const { t } = useTranslation();

    /**
     * Formats time to 12-hour format with am/pm
     * @param {string} dateString - ISO date string
     * @returns {string} Formatted time string
     */
    const formatTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).toLowerCase();
    };

    /**
     * If no schedules are available, display a message
     */
    if (schedules.length === 0) {
        return (
            <Box className="upcoming-cards no-trips">
                <p>{t('noUpcomingTrips', 'No upcoming trips scheduled')}</p>
            </Box>
        );
    }

    return (
        <>
            {schedules.map((schedule) => (
                <Box key={schedule.id} className="upcoming-cards">
                    <div className="top-row">
                        <span className="vehicle-name">
                            {/* Access vehicle name from vehicleSchedule array if it exists */}
                            {schedule.vehicleSchedule && 
                             schedule.vehicleSchedule.length > 0 && 
                             schedule.vehicleSchedule[0].vehicle?.name || 
                             t('vehicleNotAssigned', 'Vehicle Not Assigned')}
                        </span>
                        <div className='time'>
                            <img src={UpcomingTimeIcon} alt={t('timeAlt', 'Time')} />
                            <span>{formatTime(schedule.startTime)}</span>
                        </div>
                    </div>
                    <div className="bottom-row">
                        <img src={UpcomingRouteIcon} alt={t('routeAlt', 'Route')} />
                        <div>
                            {/* Display route name from the route object */}
                            <span className="location">
                                {schedule.route?.name || 
                                 t('routeNotAssigned', 'Route Not Assigned')}
                            </span>
                        </div>
                    </div>
                </Box>
            ))}
        </>
    );
}